import API_BASE_URL from "../../../../../Constants";

// Fetch all contacts that can be assigned to a building
export const fetchAllContacts = async () => {
  const response = await fetch(`${API_BASE_URL}/api/setup/contacts/get-all`, {
    credentials: "include",
  });
  if (!response.ok) throw new Error("Failed to fetch contacts");
  const allContacts = await response.json();

  return allContacts;
};

// Fetch assigned contacts for a specific building
export const fetchAssignedContacts = async (buildingId) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/building-contact-intersections/building/${buildingId}`,
    {
      credentials: "include",
    }
  );
  if (!response.ok) throw new Error("Failed to fetch assigned contacts");
  return response.json();
};

// Update the list of assigned contacts for a building
export const updateAssignedContacts = async (buildingId, contacts) => {
  const contactsDto = contacts.map((contact) => ({
    contactId: contact.contactID,
    buildingId: buildingId,
    mainContact: contact.mainContact || false,
    agentContact: contact.agentContact || false,
    superintendentContact: contact.superintendentContact || false,
    collectionsContact: contact.collectionsContact || false,
    dobContact: contact.dobContact || false,
  }));

  const response = await fetch(
    `${API_BASE_URL}/api/setup/building-contact-intersections/update/${buildingId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(contactsDto),
    }
  );
  if (!response.ok) throw new Error("Failed to update assigned contacts");
};

export const updateContact = async (contactId, contactData) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/contacts/${contactId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(contactData),
      credentials: "include",
    }
  );
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to update contact");
  }
  return response.json();
};

export const addNewContact = async (contactData) => {
  const response = await fetch(`${API_BASE_URL}/api/setup/contacts`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(contactData),
    credentials: "include",
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to add contact");
  }

  return response.json();
};
